// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.block_gradient {
    width: 100%;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
}

@media only screen and (max-width: 1800px){
    .inner-banner .block_gradient {
        width: 110%;
    }

}

@media (min-width: 1500px){
    .inner-banner {
        padding: 5.5rem 0 8.125rem;
    }

}

@media (min-width: 992px){
    .inner-banner {
        padding: 1.875rem 0 3.75rem;
    }
}

@media only screen and (max-width: 1400px){
    .inner-banner .block_gradient {
        width: 118%;
    }

}
@media only screen and (max-width: 1800px){
    .inner-banner .block_gradient {
        width: 110%;
    }

}
@media (max-width: 575.98px){
    .inner-banner .block_gradient {
        clip-path: ellipse(200% 100% at top center) !important;
        -webkit-clip-path: ellipse(200% 100% at top center) !important;
    }
    /* section .container {
        padding: 0 2.1875rem !important;
    } */
    .inner-banner .banner-image-circle img {
        width: 100% !important;
        max-width: 19.75rem!important;
    }
    .inner-banner .hero-banner-circle {
        width: 10.875rem !important;
        height: 10.875rem !important;
        left: -2.7rem !important;
        right: 0 !important;
        margin: 0 auto !important;
    }
    .inner-banner .banner-image-circle {
        width: 100% !important;
        top: 0 !important;
        transform: scale(1) !important;
        text-align: center !important;
        left: 20px !important;
    }
}
@media (max-width: 767.98px){
    /* .inner-banner .block_gradient {
        clip-path: ellipse(150% 100% at top center);
        -webkit-clip-path: ellipse(150% 100% at top center);
    } */

}
@media (max-width: 991.98px){
    .inner-banner .block_gradient {
        clip-path: ellipse(100% 100% at top center) !important;
        -webkit-clip-path: ellipse(100% 100% at top center) !important;
        left: 0!important;
        width: 100% !important;
    }
    .inner-banner .banner-content-image-wrap {
        flex-wrap: wrap !important;
    }
    .inner-banner .banner-image-circle {
        width: 64% !important;
        top: 0 !important;
        /* transform: scale(1) !important; */
        text-align: center !important;
    }
    .inner-banner .hero-banner-circle {
        left: -5rem;
        margin: 0 auto;
        width: 19.375rem;
        height: 19.375rem;
    }
    .inner-banner .banner_content {
        width: 100% !important;
        margin-bottom: 1.875rem !important;
    }
}


@media (max-width: 1199.98px){
    .inner-banner .banner-image-circle {
        left: 0;
        transform: scale(.7);
    }
}

@media (max-width: 1399.98px){
    .inner-banner .banner_content h1, .inner-banner .banner_content .h1 {
        font-size: 2.25rem;
        line-height: 2.75rem;
        margin-bottom: 1.5625rem;
    }
}

@media (max-width: 1499.98px){
    .inner-banner .banner-image-circle {
        top: 3.125rem;
        transform: scale(.8);
        width: 55%;
    }
    .inner-banner .banner_content h1, .inner-banner .banner_content .h1 {
        font-size: 2.5rem;
        line-height: 3.125rem;
        margin-bottom: 1.5625rem;
    }

}


.inner-banner {
    /* padding: 3.75rem 0 1.875rem; */
}

.inner-banner .block_gradient {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    position: absolute;
    left: -310px;
    top: 0;
    margin: 0 auto;
    clip-path: ellipse(50% 100% at top center);
    -webkit-clip-path: ellipse(50% 100% at top center);
}

.inner-banner .banner_content {
    width: 60%;
}

.white-text *, .white-text {
    color: #fff !important;
}

.inner-banner .banner_content h1, .inner-banner .banner_content .h1 {
    font-size: 3rem;
    line-height: 3.625rem;
    letter-spacing: 0;
    margin-bottom: 2.9375rem;
}

.inner-banner .banner-image-circle {
    position: relative;
    left: 4.0625rem;
    top: 4.375rem;
}

img, svg {
    vertical-align: middle;
}

.inner-banner .hero-banner-circle {
    width: 23.4375rem;
    height: 23.4375rem;
    border-radius: 50%;
    position: absolute;
    top: 50%;
    left: 4.0625rem;
    right: 0;
    transform: translateY(-50%);
    margin-top: 0;
}
.white-text *, .white-text {
    color: #fff !important;
}
.bgimage {
    background-size: cover !important;
    background-position: center center !important;
    background-repeat: no-repeat !important;
}

figure {
    margin: 0;
}
figure {
    margin: 0 0 1rem;
}
*, *:before, *:after {
    box-sizing: border-box;
}
user agent stylesheet
figure {
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 40px;
    margin-inline-end: 40px;
}

.inner-banner .hero-banner-circle img {
    border-radius: 50%;
}

.image-object-fit {
    width: 100% !important;
    height: 100% !important;
    object-fit: cover !important;
}
.white-text *, .white-text {
    color: #fff !important;
}
img, svg {
    vertical-align: middle;
}
*, *:before, *:after {
    box-sizing: border-box;
}
user agent stylesheet
img {
    overflow-clip-margin: content-box;
    overflow: clip;
}

.inner-banner .banner_content h1, .inner-banner .banner_content .h1 {
    font-size: 3rem;
    line-height: 3.625rem;
    letter-spacing: 0;
    margin-bottom: 2.9375rem;
}

.inner-banner .banner_content p {
    font-size: 1.25rem;
    line-height: 1.875rem;
    letter-spacing: 0;
    padding-bottom: 1.25rem;
}

section .container {
    position: relative;
    z-index: 3;
}


.inner-banner .banner_content {
    width: 60%;
}

.image-object-fit {
    width: 100% !important;
    height: 100% !important;
    object-fit: cover !important;
}`, "",{"version":3,"sources":["webpack://./src/hnh/css/serviceTab.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;AACX;;AAEA;IACI;QACI,WAAW;IACf;;AAEJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;AAEJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,WAAW;IACf;;AAEJ;AACA;IACI;QACI,WAAW;IACf;;AAEJ;AACA;IACI;QACI,sDAAsD;QACtD,8DAA8D;IAClE;IACA;;OAEG;IACH;QACI,sBAAsB;QACtB,6BAA6B;IACjC;IACA;QACI,2BAA2B;QAC3B,4BAA4B;QAC5B,wBAAwB;QACxB,mBAAmB;QACnB,yBAAyB;IAC7B;IACA;QACI,sBAAsB;QACtB,iBAAiB;QACjB,8BAA8B;QAC9B,6BAA6B;QAC7B,qBAAqB;IACzB;AACJ;AACA;IACI;;;OAGG;;AAEP;AACA;IACI;QACI,sDAAsD;QACtD,8DAA8D;QAC9D,iBAAiB;QACjB,sBAAsB;IAC1B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,qBAAqB;QACrB,iBAAiB;QACjB,oCAAoC;QACpC,6BAA6B;IACjC;IACA;QACI,WAAW;QACX,cAAc;QACd,gBAAgB;QAChB,iBAAiB;IACrB;IACA;QACI,sBAAsB;QACtB,kCAAkC;IACtC;AACJ;;;AAGA;IACI;QACI,OAAO;QACP,oBAAoB;IACxB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,oBAAoB;QACpB,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,aAAa;QACb,oBAAoB;QACpB,UAAU;IACd;IACA;QACI,iBAAiB;QACjB,qBAAqB;QACrB,wBAAwB;IAC5B;;AAEJ;;;AAGA;IACI,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,4BAA4B;IAC5B,kCAAkC;IAClC,kBAAkB;IAClB,YAAY;IACZ,MAAM;IACN,cAAc;IACd,0CAA0C;IAC1C,kDAAkD;AACtD;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,eAAe;IACf,QAAQ;IACR,2BAA2B;IAC3B,aAAa;AACjB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,iCAAiC;IACjC,6CAA6C;IAC7C,uCAAuC;AAC3C;;AAEA;IACI,SAAS;AACb;AACA;IACI,gBAAgB;AACpB;AACA;IACI,sBAAsB;AAC1B;AACA;;IAEI,cAAc;IACd,uBAAuB;IACvB,qBAAqB;IACrB,yBAAyB;IACzB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;AAChC;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;AACA;;IAEI,iCAAiC;IACjC,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;;AAGA;IACI,UAAU;AACd;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;AAChC","sourcesContent":[".block_gradient {\n    width: 100%;\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n}\n\n@media only screen and (max-width: 1800px){\n    .inner-banner .block_gradient {\n        width: 110%;\n    }\n\n}\n\n@media (min-width: 1500px){\n    .inner-banner {\n        padding: 5.5rem 0 8.125rem;\n    }\n\n}\n\n@media (min-width: 992px){\n    .inner-banner {\n        padding: 1.875rem 0 3.75rem;\n    }\n}\n\n@media only screen and (max-width: 1400px){\n    .inner-banner .block_gradient {\n        width: 118%;\n    }\n\n}\n@media only screen and (max-width: 1800px){\n    .inner-banner .block_gradient {\n        width: 110%;\n    }\n\n}\n@media (max-width: 575.98px){\n    .inner-banner .block_gradient {\n        clip-path: ellipse(200% 100% at top center) !important;\n        -webkit-clip-path: ellipse(200% 100% at top center) !important;\n    }\n    /* section .container {\n        padding: 0 2.1875rem !important;\n    } */\n    .inner-banner .banner-image-circle img {\n        width: 100% !important;\n        max-width: 19.75rem!important;\n    }\n    .inner-banner .hero-banner-circle {\n        width: 10.875rem !important;\n        height: 10.875rem !important;\n        left: -2.7rem !important;\n        right: 0 !important;\n        margin: 0 auto !important;\n    }\n    .inner-banner .banner-image-circle {\n        width: 100% !important;\n        top: 0 !important;\n        transform: scale(1) !important;\n        text-align: center !important;\n        left: 20px !important;\n    }\n}\n@media (max-width: 767.98px){\n    /* .inner-banner .block_gradient {\n        clip-path: ellipse(150% 100% at top center);\n        -webkit-clip-path: ellipse(150% 100% at top center);\n    } */\n\n}\n@media (max-width: 991.98px){\n    .inner-banner .block_gradient {\n        clip-path: ellipse(100% 100% at top center) !important;\n        -webkit-clip-path: ellipse(100% 100% at top center) !important;\n        left: 0!important;\n        width: 100% !important;\n    }\n    .inner-banner .banner-content-image-wrap {\n        flex-wrap: wrap !important;\n    }\n    .inner-banner .banner-image-circle {\n        width: 64% !important;\n        top: 0 !important;\n        /* transform: scale(1) !important; */\n        text-align: center !important;\n    }\n    .inner-banner .hero-banner-circle {\n        left: -5rem;\n        margin: 0 auto;\n        width: 19.375rem;\n        height: 19.375rem;\n    }\n    .inner-banner .banner_content {\n        width: 100% !important;\n        margin-bottom: 1.875rem !important;\n    }\n}\n\n\n@media (max-width: 1199.98px){\n    .inner-banner .banner-image-circle {\n        left: 0;\n        transform: scale(.7);\n    }\n}\n\n@media (max-width: 1399.98px){\n    .inner-banner .banner_content h1, .inner-banner .banner_content .h1 {\n        font-size: 2.25rem;\n        line-height: 2.75rem;\n        margin-bottom: 1.5625rem;\n    }\n}\n\n@media (max-width: 1499.98px){\n    .inner-banner .banner-image-circle {\n        top: 3.125rem;\n        transform: scale(.8);\n        width: 55%;\n    }\n    .inner-banner .banner_content h1, .inner-banner .banner_content .h1 {\n        font-size: 2.5rem;\n        line-height: 3.125rem;\n        margin-bottom: 1.5625rem;\n    }\n\n}\n\n\n.inner-banner {\n    /* padding: 3.75rem 0 1.875rem; */\n}\n\n.inner-banner .block_gradient {\n    width: 100%;\n    height: 100%;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center center;\n    position: absolute;\n    left: -310px;\n    top: 0;\n    margin: 0 auto;\n    clip-path: ellipse(50% 100% at top center);\n    -webkit-clip-path: ellipse(50% 100% at top center);\n}\n\n.inner-banner .banner_content {\n    width: 60%;\n}\n\n.white-text *, .white-text {\n    color: #fff !important;\n}\n\n.inner-banner .banner_content h1, .inner-banner .banner_content .h1 {\n    font-size: 3rem;\n    line-height: 3.625rem;\n    letter-spacing: 0;\n    margin-bottom: 2.9375rem;\n}\n\n.inner-banner .banner-image-circle {\n    position: relative;\n    left: 4.0625rem;\n    top: 4.375rem;\n}\n\nimg, svg {\n    vertical-align: middle;\n}\n\n.inner-banner .hero-banner-circle {\n    width: 23.4375rem;\n    height: 23.4375rem;\n    border-radius: 50%;\n    position: absolute;\n    top: 50%;\n    left: 4.0625rem;\n    right: 0;\n    transform: translateY(-50%);\n    margin-top: 0;\n}\n.white-text *, .white-text {\n    color: #fff !important;\n}\n.bgimage {\n    background-size: cover !important;\n    background-position: center center !important;\n    background-repeat: no-repeat !important;\n}\n\nfigure {\n    margin: 0;\n}\nfigure {\n    margin: 0 0 1rem;\n}\n*, *:before, *:after {\n    box-sizing: border-box;\n}\nuser agent stylesheet\nfigure {\n    display: block;\n    margin-block-start: 1em;\n    margin-block-end: 1em;\n    margin-inline-start: 40px;\n    margin-inline-end: 40px;\n}\n\n.inner-banner .hero-banner-circle img {\n    border-radius: 50%;\n}\n\n.image-object-fit {\n    width: 100% !important;\n    height: 100% !important;\n    object-fit: cover !important;\n}\n.white-text *, .white-text {\n    color: #fff !important;\n}\nimg, svg {\n    vertical-align: middle;\n}\n*, *:before, *:after {\n    box-sizing: border-box;\n}\nuser agent stylesheet\nimg {\n    overflow-clip-margin: content-box;\n    overflow: clip;\n}\n\n.inner-banner .banner_content h1, .inner-banner .banner_content .h1 {\n    font-size: 3rem;\n    line-height: 3.625rem;\n    letter-spacing: 0;\n    margin-bottom: 2.9375rem;\n}\n\n.inner-banner .banner_content p {\n    font-size: 1.25rem;\n    line-height: 1.875rem;\n    letter-spacing: 0;\n    padding-bottom: 1.25rem;\n}\n\nsection .container {\n    position: relative;\n    z-index: 3;\n}\n\n\n.inner-banner .banner_content {\n    width: 60%;\n}\n\n.image-object-fit {\n    width: 100% !important;\n    height: 100% !important;\n    object-fit: cover !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
